/**
 *
 * SectionHeader
 *
 */
import * as React from 'react';
import { Box } from '@mui/material';
import fonts from 'app/assets/styles/fonts';
import colors from 'app/assets/styles/colors';

interface Props {
  title: React.ReactNode;
}

export function SectionHeader(props: Props) {
  return (
    <Box display="flex" alignContent="baseline" pb={2} pt={2}>
      <Box
        whiteSpace="nowrap"
        pr={3}
        fontWeight={500}
        fontSize={fonts.large}
        color={colors.dudeNavy}
      >
        {props.title}
      </Box>
      <Box
        borderTop={`2px solid ${colors.steelGray}`}
        width="100%"
        margin="auto"
      />
    </Box>
  );
}
